var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tooltip',{attrs:{"text":_vm.customTooltip}},[_c('span',[_c('vs-icon',{class:{
          'text-success': _vm.status === 'validated',
          'text-warning': _vm.status === 'pending_validation',
          'text-danger': _vm.status === 'error',
        },attrs:{"icon":"circle"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }